// extracted by mini-css-extract-plugin
export var divider = "_eg-7";
export var itemsToggle = "_eg-8";
export var mergeModal = "_eg-1";
export var optionCard = "_eg-4";
export var radioGroup = "_eg-6";
export var radioOption = "_eg-0";
export var selected = "_eg-5";
export var shipmentOptions = "_eg-2";
export var tableOptions = "_eg-3";